import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// ACCOUNTS STATUS LIST RELATED APIs
// ==============================================

// 1. Get Status List for Account Operations
export const getStatusList = async (params) => {
    try {
        const { MOID, ROID, ChkAmt } = params;
         // DEBUG
        
        const queryParams = new URLSearchParams({
            MOID: MOID || '',
            ROID: ROID || '',
            ChkAmt: ChkAmt || '0'
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetStatuslist?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Bank Details with Available Balance
export const getBankDetailsWithAvailableBalance = async () => {
    try {


        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetBankDetailsWithAvailableBalance`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};